import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UploadReqStepWorkflowComponent } from './upload-req-step-workflow.component';

@NgModule({
  declarations: [UploadReqStepWorkflowComponent],
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule
  ],
  exports: [UploadReqStepWorkflowComponent],
  entryComponents: [UploadReqStepWorkflowComponent]
})
export class UploadReqStepWorkflowModule { }
